import { ScanProgress } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { Animated, StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
interface IProps {
  totalSteps: number;
  step: number;
  progress: ScanProgress;
  t: (key: string) => string;
}

interface IState {
  animation: Animated.Value;
}

export class StepProgress extends PureComponent<IProps, IState> {
  public state = {
    animation: new Animated.Value(0),
  };

  public componentDidMount = () => {
    this.doAStep();
  }

  public componentDidUpdate = (prevProps) => {
    if (this.props.step !== prevProps.step) {
      this.doAStep();
    }
  }

  public render() {
    const { animation } = this.state;
    const width = animation.interpolate({
      inputRange: [0, 100],
      outputRange: ['0%', '100%'],
      extrapolate: 'extend',
    });
    const headerTitles = {
      [ScanProgress.CaptureMetrics]: this.props.t('bodyAssessment'),
      [ScanProgress.Onboarding]: this.props.t('bodyScanSetup'),
      [ScanProgress.AssessmentResults]: this.props.t('assessmentResults'),
    };

    return (
      <View style={styles.progressStyle}>
        <View style={styles.bar}>
          <Animated.View style={[
            StyleSheet.absoluteFill, {
              width,
              backgroundColor: Theme.PRIMARY,
              borderRadius: 5,
            }]} />
        </View>
        <Text style={styles.assessmentHeaderTextStyle}>
          {headerTitles[this.props.progress]}
        </Text>
      </View>

    );
  }

  private doAStep() {
    const { animation } = this.state;
    const { step, totalSteps = 6 } = this.props;
    Animated.timing(animation, {
      toValue: (step / totalSteps) * 100,
      duration: 500,
    } as any).start();
  }
}

const styles = StyleSheet.create({
  bar: {
    height: 10,
    width: '100%',
    backgroundColor: Theme.GREY_LIGHT,
    borderRadius: 5,
  },
  progressStyle: {
    marginTop: defaultScale(12),
    marginBottom: defaultScale(10),
    marginRight: defaultScale(20),
  },
  assessmentHeaderTextStyle: {
    ...Theme.textStyle.bodyCopyMed,
    zIndex: 1,
    paddingBottom: defaultScale(10),
    fontSize: defaultScale(20),
  },
});
